import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router-dom'
import { Box, Divider, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { DatePicker, Radio } from 'antd'

import ModuleGraph from './components/ModuleGraph'
import SummaryPieChart from './components/SummaryPieChart'
import SummaryBarChart from './components/SummaryBarChart'

import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import moment from 'moment'
import dayjs from 'dayjs'

const AlertSummary = () => {
  const { t } = useTranslation()
  const { send } = useFetchData()
  const { projectInfo, alertTypes, alertEvents, setPageLoading } = useOutletContext()

  const [date, setDate] = useState([new Date(), new Date()])
  const [reportAlert, setReporAlert] = useState([])
  const [projectModules, setProjectModules] = useState()
  const [alertExist, setAlertExist] = useState(false)
  const [mode, setMode] = useState("0")

  const getReportAlert = async (modules, dateRange) => {
    setAlertExist(false)

    const getCount = (type, status) => {
      const item = body1.filter((i) => i["type"] === type && (status == null || i['status'] === status))
      
      if (item.length === 0) {
        return 0
      }

      setAlertExist(true)

      return item.map((i) => i["count"]).reduce((partialSum, a) => partialSum + a, 0)
    }

    setPageLoading(true)

    const body1 = await send({
      method: "GET",
      url: `${apiUrl}/dashboard/alert_summary`,
      params: {
        "start_date": moment(dateRange[0]).format("YYYY-MM-DD"),
        "end_date": moment(dateRange[1]).format("YYYY-MM-DD")
      },
      returnType: "json"
    })

    const body2 = await send({
      method: "GET",
      url: `${apiUrl}/dashboard/alert_summary2`,
      params: {
        "start_date": moment(dateRange[0]).format("YYYY-MM-DD"),
        "end_date": moment(dateRange[1]).format("YYYY-MM-DD")
      },
      returnType: "json"
    })

    const data1 = []
    const data2 = []
    const data3 = {}

    Object.keys(alertTypes).forEach((i) => {
      if (modules.includes(i)) {
        data1.push({ "name": t(`${alertTypes[i]}`), "value": getCount(i) })
        data2.push({ "name": t(`${alertTypes[i]}`), "0": getCount(i, 0), "1": getCount(i, 1), "2": getCount(i, 2), "-1": getCount(i, -1) })

        const d0 = moment(dateRange[0]).startOf('day').add(-1, 'days')
        const d1 = moment(dateRange[1]).startOf('day').add(1, 'days')
        const temp1 = []

        while(d0.add(1, 'days').diff(d1) < 0) {
          const d = d0.format("YYYY-MM-DD")

          const temp2 = { "name": d }

          Object.keys(alertEvents[i]).forEach((k) => {
            const value = body2.filter((j) => j["date"] === d && j["type"] === i && j["event"] === k)
            temp2[k] = value.length > 0 ? value[0]["count"]: 0
          })

          temp1.push(temp2)
        }

        data3[i] = temp1
      }
    })

    setReporAlert([data1, data2, data3])

    setPageLoading(false)
  }

  useEffect(() => {
    const init = async (modules) => {
      setPageLoading(true)
      
      setProjectModules(modules)

      await Promise.all([
        getReportAlert(modules, date),
      ])

      setPageLoading(false)
    }

    if (projectInfo != null) {      
      const modules = projectInfo["modules"].filter((i) => i["enabled"] === true).map((i) => i["module"])
      init(modules)
    }
  }, [projectInfo])

  const handleReportDateChange = async (value) => {
    const d = [new Date(value[0]), new Date(value[1])]

    setDate(d)
    await getReportAlert(projectModules, d)
  }

  const onModeChange = async (value) => {
    let d = null

    switch (value) {
      case "0":
        d = [new Date(moment()), new Date(moment())]
        break
      case "1":
        d = [new Date(moment().subtract(6, 'day')), new Date(moment())]
        break
      case "2":
        d = [new Date(moment().subtract(1, 'month').add(1, 'day')), new Date(moment())]
        break
      default:
        break
    }

    if (d) {
      setDate(d)
      await getReportAlert(projectModules, d)
    }

    setMode(value)
  }
    
  return (<>
    <div className="mainContainer" style={{ backgroundColor: "#FFFFFF", borderRadius: "15px", padding: "5px" }}>
      <div style={{ height: "100%", overflow: "auto" }}>
        <Box sx={{ height: "100%", minWidth: { xs: "900px", xl: alertExist ? "1300px" : "500px" } }}>
          <Box sx={{ display: "flex", flexFlow: "column", height: "100%", width: "100%" }}>
            {(projectInfo != null) &&
              <div style={{ height: "100%"}}>
                {(reportAlert) && <>
                  <div style={{ padding: "10px", width: "100%", height: "100%", display: "flex", flexFlow: "column"  }}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "end", alignItems: "center", paddingBottom: "10px" }}>
                      <Box sx={{ display: "flex", flexDirection: { xs: "column", lg: "row" } }}>
                        <Box sx={{ marginRight: { xs: "0px", lg: "3px" }, marginBottom: { xs: "3px", lg: "0px" } }}>
                          <Radio.Group style={{ width: "350px" }}
                            block optionType="button" buttonStyle="solid" defaultValue="0"
                            value={mode} onChange={(e) => onModeChange(e.target.value)}
                            options={[
                              { label: '1 Day', value: '0' },
                              { label: '7 Days', value: '1' },
                              { label: '1 Month ', value: '2' },
                              { label: 'Custom', value: '3' },
                            ]}
                          />
                        </Box>

                        <Box sx={{ marginLeft: { xs: "0px", lg: "3px" }, marginTop: { xs: "3px", lg: "0px" } }}>
                          <DatePicker.RangePicker
                            style={{ width: "100%" }} maxDate={dayjs(moment().format("YYYY-MM-DD"))} value={[dayjs(date[0]), dayjs(date[1])]}
                            popupStyle={{ zIndex: 1500 }}
                            onChange={(value) => handleReportDateChange(value)}
                            disabled={mode != "3"}
                          />
                        </Box>
                      </Box>
                    </div>
                    
                    {alertExist ? (<>
                      <div style={{ flexGrow: 1 }}>
                        <Typography variant="h6" style={{ marginTop: "30px" }}><b>{t("alert_alertSummary")}</b></Typography>

                        <div style={{ width: "100%" }}>
                          <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, xl: 4 }}>
                              <SummaryPieChart data={reportAlert[0]} projectModules={projectModules} alertTypes={alertTypes} alertEvents={alertEvents}/>
                            </Grid>
                            <Grid item size={{ xs: 12, xl: 8 }}>
                              <SummaryBarChart data={reportAlert[1]} projectModules={projectModules} />
                            </Grid>
                          </Grid>
                        </div>

                        <Divider sx={{ bgcolor: "secondary.light" }}/>

                        <div style={{ width: "100%" }}>
                          <Grid container spacing={2}>
                            {Object.keys(alertTypes).filter((i) => projectModules.includes(i)).map((i) => <>
                              <Grid item size={{ xs: 12, xl: 6 }}>
                                <ModuleGraph projectModules={projectModules} alertTypes={alertTypes} alertEvents={alertEvents} module={i} data={reportAlert[2][i]} />
                              </Grid>
                            </>)}
                          </Grid>
                        </div>
                      </div>
                    </>) : (<>
                      <div style={{ display: "flex", alignItems: "center" , justifyContent: "center", paddingTop: "50px"}}>
                        <div>{t("alert_noRecord")}</div>
                      </div>
                    </>)}
                  </div>
                </>}
              </div>
            }
          </Box>
        </Box>
      </div>
    </div>
  </>)
}

export default AlertSummary
